var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"typeChat",on:{"click":function($event){return _vm.toggleChatWindowStatus(_vm.type)}}},[_c('div',{staticClass:"type-wrapper",domProps:{"innerHTML":_vm._s(_vm.type.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }